import { Snippet } from '@distribute/shared/types';

import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { SharePreview, useShareParams } from '../../../entities/share';
import { navigate } from '../../../processes/navigation';

import { snippetsModel } from '../../../features/snippets';

type Props = {
  snippets: Snippet[];
};

export const useShareSnippetHandler = ({ snippets }: Props) => {
  const { pathname } = useLocation();

  const { params } = useShareParams();

  const dispatch = useDispatch();

  const snippetToPreview = useMemo(() => {
    if (!params.id || !params.teamId) return null;

    const snippet = snippets.find((snippet) => snippet.id === params.id);

    return snippet
      ? { type: SharePreview.ALLOWED, data: snippet }
      : { type: SharePreview.FORBIDDEN };
  }, [params, snippets]);

  useEffect(() => {
    if (
      snippetToPreview?.type === SharePreview.ALLOWED &&
      snippetToPreview.data
    ) {
      dispatch(
        snippetsModel.actions.setModal({
          type: 'snippetPreview',
          snippet: snippetToPreview.data,
        })
      );
      dispatch(navigate({ to: pathname, isKeepQueryParams: false }));
    }
  }, [snippetToPreview, pathname, dispatch]);

  return { isForbidden: snippetToPreview?.type === SharePreview.FORBIDDEN };
};
